export default __webpack_public_path__ + "static/media/BFS-logo.81c61f08.png";